
<div class="square-outer" >
    <h2>{{'appointmentInfo' | translate | uppercase}}</h2>
      <p>
        <span class="bold">{{ getNamePerson$() | async }}</span>
        {{ 'appointmentInfoMssg2' | translate}} <span class="bold">{{ appointmentDate | date: 'shortTime' }}</span>
        {{ 'appointmentInfoMssg3' | translate}} <span class="bold">{{ appointmentDate | date: 'dd/MM/yyyy' }}</span>

      </p>
</div>
<app-contact-phones ></app-contact-phones>
